"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YearPicker = void 0;

var tslib_1 = require("tslib");

var ui_box_1 = require("@hopin-team/ui-box");

var ui_butticon_1 = require("@hopin-team/ui-butticon");

var ui_button_1 = require("@hopin-team/ui-button");

var ui_grid_1 = require("@hopin-team/ui-grid");

var ui_text_1 = require("@hopin-team/ui-text");

var date_fns_1 = require("date-fns");

var lodash_chunk_1 = tslib_1.__importDefault(require("lodash.chunk"));

var react_1 = tslib_1.__importStar(require("react"));

var context_1 = require("../context");

var generate_years_1 = require("../lib/generate-years");

var calendar_grid_1 = require("../styled/calendar-grid");

var table_1 = require("./table");

var year_1 = require("./year");

var ROW = 3;
var PERIOD = 4;

var YearPicker = function YearPicker() {
  var _a = (0, react_1.useContext)(context_1.DateFieldContext),
      _b = _a.date,
      date = _b === void 0 ? new Date() : _b,
      onDateChange = _a.onDateChange,
      onDatePick = _a.onDatePick,
      onRangePick = _a.onRangePick,
      withRange = _a.withRange;

  var onSelect = function onSelect(date) {
    onDateChange(date);
    withRange ? onRangePick() : onDatePick();
  };

  var onPrevious = function onPrevious() {
    return onDateChange((0, date_fns_1.subYears)(date, PERIOD + 1));
  };

  var onNext = function onNext() {
    return onDateChange((0, date_fns_1.addYears)(date, PERIOD + 1));
  };

  var currentYear = (0, date_fns_1.getYear)(date);
  var years = (0, generate_years_1.generateYears)({
    currentYear: currentYear,
    period: PERIOD
  });
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(ui_grid_1.Grid, {
    gridTemplateColumns: "2rem 1fr 1fr 2rem",
    gridGap: "0.5rem",
    px: 2,
    py: 1
  }, react_1.default.createElement(ui_butticon_1.Butticon, {
    icon: "arrow-back",
    size: "tiny",
    title: "Previous",
    onClick: onPrevious,
    type: "button",
    my: 0.5
  }), react_1.default.createElement(ui_button_1.Button, {
    size: "small",
    pattern: "secondary",
    isOutlined: true,
    disabled: true,
    type: "button"
  }, react_1.default.createElement(ui_text_1.Text, {
    pattern: "caption"
  }, (0, date_fns_1.format)(date, 'MMMM'))), react_1.default.createElement(ui_button_1.Button, {
    size: "small",
    pattern: "secondary",
    isOutlined: true,
    disabled: true,
    type: "button"
  }, react_1.default.createElement(ui_text_1.Text, {
    pattern: "caption"
  }, (0, date_fns_1.format)(date, 'yyyy'))), react_1.default.createElement(ui_butticon_1.Butticon, {
    icon: "arrow-forward",
    size: "tiny",
    title: "Next",
    onClick: onNext,
    type: "button",
    my: 0.5,
    ml: 1
  })), react_1.default.createElement(ui_box_1.Box, {
    p: 2
  }, react_1.default.createElement(table_1.Table, {
    type: "year",
    label: "Years",
    date: date,
    onDateChange: onDateChange,
    onSelect: onDatePick
  }, react_1.default.createElement(calendar_grid_1.CalendarGrid, null, (0, lodash_chunk_1.default)(years, ROW).map(function (yearGroup, i) {
    return react_1.default.createElement("tr", {
      key: "year-".concat(i)
    }, yearGroup.map(function (year, t) {
      return react_1.default.createElement(year_1.Year, {
        selectedDate: date,
        key: "year-cell-".concat(i * ROW + t + 1),
        date: new Date(year, (0, date_fns_1.getMonth)(date), (0, date_fns_1.getDate)(date)),
        onSelect: onSelect
      });
    }));
  })))));
};

exports.YearPicker = YearPicker;